import {
  Box,
  Typography,
  Button,
  SxProps,
  CircularProgress,
} from '@mui/material';
import { t } from 'i18next';
import { ReactNode } from 'react';
import { CustomModal } from '../CustomModal';

interface IConfirmationModalProps {
  title: string;
  message: string;
  onConfirm: () => void;
  onClose: () => void;
  isOpen: boolean;
  isLoading?: boolean;
  disableCloseOnOutsideClick?: boolean;
  confirmText?: string;
  closeText?: string;
  banner?: ReactNode;
  sx?: SxProps;
  reverseButtonOrder?: boolean;
}

export const ConfirmationModal = ({
  onClose,
  onConfirm,
  isOpen,
  message,
  title,
  banner,
  confirmText = t('general.continue'),
  closeText = t('general.cancel'),
  isLoading = false,
  disableCloseOnOutsideClick = false,
  reverseButtonOrder = false,
}: IConfirmationModalProps) => {
  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      isLoading={isLoading}
      disableCloseOnOutsideClick={disableCloseOnOutsideClick}
    >
      <Typography>{message}</Typography>
      {banner && <Box sx={{ marginTop: 2 }}>{banner}</Box>}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', py: 3 }}>
        <Button
          key='confirmation-close-button'
          onClick={reverseButtonOrder ? onConfirm : onClose}
          sx={{ mr: 1 }}
          disabled={isLoading}
        >
          {reverseButtonOrder ? confirmText : closeText}
        </Button>
        <Button
          key='confirmation-confirm-button'
          onClick={reverseButtonOrder ? onClose : onConfirm}
          startIcon={
            isLoading && <CircularProgress size={16} color='inherit' />
          }
          variant='contained'
          color='secondary'
          loadingPosition='center'
          disabled={isLoading}
          sx={{ color: 'white' }}
        >
          {reverseButtonOrder ? closeText : confirmText}
        </Button>
      </Box>
    </CustomModal>
  );
};
